import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const LoadingScreen = ({ message }) => {
    return (_jsxs("div", { "data-testid": 'loading-screen', style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            margin: 0,
            padding: 0,
            backgroundColor: '#FFFFFF',
            zIndex: 9999,
        }, children: [_jsx("div", { "data-testid": 'loading-spinner', style: {
                    width: '44px',
                    height: '44px',
                    marginBottom: '16px',
                    border: '4px solid #D9D9D9',
                    borderTop: '4px solid #D64000',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                } }), message && (_jsx("div", { "data-testid": 'loading-message', style: {
                    color: '#666',
                    fontSize: '14px',
                    fontFamily: '"Source Sans 3", sans-serif',
                    textAlign: 'center',
                }, children: message })), _jsx("style", { "data-testid": 'loading-keyframes', children: `
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      ` })] }));
};
